export default {
	API_URL: 'https://api-viva.infinitum-ti.com/api',
	OAPI_URL: 'https://api-viva.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2384/api',
	// OAPI_URL: 'http://localhost:2384/oapi',
}
